import './CSS/Estilo.css';
import {estiloGreen,estiloDark} from "./CSS/EstilosPagina";
import ToolBar from "./Componentes/SubComponentes/ToolBar";
import MenuDesplegable from "./Componentes/MenuDesplegable";
import MenuLateral from "./Componentes/MenuLateral"
import WebViewer from "./Componentes/SubComponentes/WebViewer"
import PdfViewer from "./Componentes/SubComponentes/PdfViewer";
import React,{useState, useEffect, useCallback} from "react";
import WebTheme from "./Componentes/SubComponentes/WebTheme";
import {Box,} from '@mui/material';
import {fetchRequest} from "./Componentes/RequestUtils";
import Footer from "./Componentes/SubComponentes/Footer";
import ImageGalleryViewer from "./Componentes/SubComponentes/ImageGalleryViewer";
import OraxTable from "./Componentes/SubComponentes/OraxTable";

export default function OraxNews({ip,port,protocolo,modo,modo_desarrollo}) {

    const opciones = ['Dark', 'Green']
    const pages = ['Inicio', 'Sobre nosotros', 'Contacto', 'Área privada'];
    //Array de strings con los rotulos que apareceran en cada una de las opciones principales
    const lateralMenuOptions = ['Último evento', 'Galería de fotos', 'Comunicado', 'Documentos']
    //Array de arrays de strings con las subopciones que apareceran cuando se despliegue cada una de las opciones principales
    const lateralMenuSubOptions = [['Eventos anteriores', 'Buscador'], ['Buscador Imagenes'], ['Comunicados anteriores']]

    const [estiloPagina, setEstiloPagina] = useState((localStorage.getItem('estilo') === 'Dark') ? estiloDark
        : estiloGreen);
    const [rotuloWeb, setRotuloWeb] = useState("Último evento"); //Para el rotulo de un evento
    const [textosWeb, setTextosWeb] = useState([]); //Para las narraciones de los eventos
    const [imagenesWeb, setImagenesWeb] = useState([]); //Para la lista de listas de imagenes de la galeria
    const [eventsList, setEventsList] = useState([]); // Para la lista de eventos anteriores
    const [openIndex, setOpenIndex] = useState(null); // Para el indice de la opcion del menu pulsada
    const [showingWebImages, setShowingWebImages] = useState(false); // Indica si se está mostrando la galeria o no
    const [webImagesArrays, setWebImagesArrays] = useState([]); // Array de arrays de imagenes web para galeria
    const [documents, setDocuments] = useState([]); //Array de documentos pdf que se van a visualizar (anuncios o documentos de usuario)
    const [showingDocument, setShowingDocument] = useState(false); //Indica si se está mostrando un documento (anuncios o documento de usuario)
    const [pastWebNotices, setPastWebNotices] = useState([]); // Para la lista de anuncios anteriores ( con fecha expirada)
    const [showingPastNotices, setShowingPastNotices] = useState(false); //Indica que se están mostrando links a documentos pasados
    const [sharedDocuments, setSharedDocuments] = useState([]); // Para la lista de ficheros compartidos de todos los usuarios
    const [showingSharedDocuments, setShowingSharedDocuments] = useState(false); //Indica que se está visualizando la tabla de ficheros compartidos

    const opcionesOnClick = useCallback((ev) => {
        let pulsado = ev.target.id;
        let estilo = (pulsado === 'Dark') ? estiloDark : estiloGreen;
        setEstiloPagina(() => estilo);
        localStorage.setItem('estilo', pulsado);
    }, []);

    const sharedDocumentsListColumns = [
        { field: 'filename', headerName: 'Nombre del documento', flex:0.3,valueGetter: (value, row) => {
                const filePath = value || row?.filename;
                return filePath ? filePath.split(/[\/\\]/).pop() : '';
            },
            renderCell: (params) => {
                // La ruta completa viene en params.row.filename (o params.value)
                const fullPath = params.row?.filename || params.value || '';

                // Extraemos solo el nombre del fichero
                const fileNameOnly = fullPath ? fullPath.split(/[\/\\]/).pop() : '';

                return (
                    <a
                        onClick={requestFileByLinkName}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                        {fileNameOnly}
                    </a>
                );
            },
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD')
            ,headerAlign:'center',align:'center', cellClassName:'lineasTablaDerecha'},
        { field: 'description', headerName: 'Descripción del documento', flex:0.3,
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),headerAlign:'center',align:'center',
            cellClassName:'lineasTablaDerecha'},
        { field: 'owner', headerName: 'Compartido por', flex:0.2, headerAlign:'center',align:'center',
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),cellClassName:'lineasTablaDerecha'},
        { field: 'mimeType', headerName: 'Tipo de fichero', flex:0.1,headerAlign:'center',align:'center',
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),cellClassName:'lineasTablaDerecha'},
        { field: 'uploadDate', headerName: 'Fecha de subida', flex:0.1,headerAlign:'center',align:'center',
            headerClassName: ((localStorage.getItem('estilo') === 'Green')?'headerUsersTableG':'headerUsersTableD'),cellClassName:'lineasTablaDerecha'},
    ];

    useEffect(() => {
        // Esta función se ejecuta al cargar el componente
        setRotuloWeb(() => "último evento");
        setTextosWeb(() => []);
        setImagenesWeb(() => []);
        setWebImagesArrays(()=>[]);
        requestFileObjectArray("LastEventContents");
    }, []); // [] asegura que se ejecute solo una vez

    const resetStates = () =>{
        setEventsList([]);
        setTextosWeb(() => []);
        setImagenesWeb(() => []);
        setWebImagesArrays(()=>[]);
        setShowingWebImages(()=> false);
        setShowingDocument(()=>false);
        setShowingPastNotices(()=>false);
        setShowingSharedDocuments(()=>false);
        setDocuments(()=>[]);
    }

    const requestFileObjectArray = (requestType) => {
        //Resetear todos los states
        resetStates();
        //Determinar el tipo de contenido que se quiere obtener
        if(requestType === "LastEventContents")
            console.log('Ejecutando petición para contenidos último evento al cargar la página');
        else if(requestType === "CurrentAdvertisments")
        {
            console.log("Ejecutando petición de todos los comunicados vigentes");
            setShowingDocument(true);
        }
        const callback = async (response) => {
            if (response) {
                if (response.data.getFileObjectArray) {
                    let datos = response.data.getFileObjectArray;
                    if(requestType === "CurrentAdvertisments")
                    {
                        //Extraer los ficheros a partir de las URL'S y ponerlas en una array
                        let pdf_files = [];
                        for (const file of datos) {
                            //Eliminar la fecha de expiración y la extensión del nombre del fichero
                            const last_dash = file.filename.lastIndexOf("-");
                            const second_dash = file.filename.lastIndexOf("-", last_dash - 1);
                            const third_dash = file.filename.lastIndexOf("-", second_dash - 1);
                            const nombre_fichero = file.filename.substring(0, third_dash);

                            let pdf_data_object = {
                                url: file.url,
                                name: nombre_fichero
                            }
                            pdf_files.push(pdf_data_object);
                        }
                        // Aquí se actualiza el state cuando todo está listo
                        setDocuments(() => pdf_files);
                    }
                    else {
                        //Leer los datos del texto del ultimo evento y sus imagenes
                        datos.forEach((file) => {
                            console.log("Fichero a leer: ", file.filename);
                            leerArchivo(file);
                        });
                    }
                } else
                    alert("Error interno del servidor. No se ha podido cargar el contenido");
            } else
                alert("Error, no se ha recibido respuesta del servidor");
        }
        fetchRequest('getFileObjectArray',
            [{nombre: 'requestType',valor:requestType}],
            'POST', ip, port, protocolo, 'json', callback,
            ['filename', 'mimeType', 'url'],
            modo_desarrollo);
    };

    async function leerArchivo(file, is_web_image) {
        try {
            console.log('Petición de leer el fichero con datos: ', file);
            const response = await fetch(file.url);
            if (!response.ok) throw new Error("Error al leer el archivo");

            // Manejo de textos
            if (file.mimeType === 'text/html' || file.mimeType === 'text/plain') {
                const text = await response.text();
                if (file.filename.includes('event_name')) {
                    const rotulo = (text.substring(0, text.indexOf('.zip'))).replaceAll('_', ' ');
                    setRotuloWeb(rotulo);
                } else {
                    //Si tiene "ficticio" en el nombre, se trata de nombres de eventos para la galeria de imagenes
                    if(file.filename.includes('ficticio'))
                    {
                        let texto_recortado = text.slice(0,-4);
                        let texto_sin_guiones = texto_recortado.replace('_',' ');
                        setTextosWeb(prev => [...prev, texto_sin_guiones]);
                    }
                    else
                        setTextosWeb(prev => [...prev, text]);  // Se trata del texto de un evento
                }
                return null; // No se retorna URL en este caso
            }
            // Manejo de imágenes
            else if (file.mimeType === 'image/png') {
                const blob = await response.blob();
                const url = URL.createObjectURL(blob);

                if (!is_web_image) {
                    // Imagen de evento (no galería)
                    setImagenesWeb(prev => [...prev, url]);
                    return null;
                } else {
                    // Imagen para la galería
                    return url;
                }
            }
            // Otro tipo de archivo no manejado
            else {
                console.warn("Tipo MIME no soportado:", file.mimeType);
                return null;
            }
        } catch (err) {
            console.error("Error al obtener el archivo:", err);
            return null;
        }
    }

    const handleLateralMenuOptionsClick = useCallback((index) => {
        setOpenIndex(()=>index);
        switch (index) {
            case 0:
                requestFileObjectArray("LastEventContents");
                break;
            case 1:
                requestWebImages();
                break;
            case 2:
                //Petición de anuncios web vigentes al servidor
                requestFileObjectArray("CurrentAdvertisments");
                break;
            case 3:
                //Petición de Documentos compartidos de todos los usuarios
                requestSharedDocuments();
                break;
            default:
                setOpenIndex(() => -1);
                return;
        }
    },[openIndex])

    const handleLateralMenuSubOptions = useCallback((ev) => {
        switch (ev.currentTarget.id) {
            case "Eventos anteriores":
                RequestFileNamesArray("pastEvents")
                break;
            case "Buscador":
                alert("En construcción.");
                break;
            case "Buscador Imagenes":
                alert("También en construcción");
                break;
            case "Comunicados anteriores":
                RequestFileNamesArray("pastAdvertisements")
                break;                    
            default:
                return;
        }
    },[])

    /* Obtiene los textos e imagenes correspondientes a un evento pasado al hacer click sobre su link */
    function requestPastEventLink(ev) {
        ev.preventDefault(); // Evita que el enlace navegue o recargue la página
       //Resetear los state
        resetStates();
        const callback = (response) => {
            if (response) {
                if (response.data.getPastWebContents) {
                    let datos = response.data.getPastWebContents;
                    if (datos.length) {
                        //Vaciar la lista de eventos anteriores para que se muestre el contenido web
                        setEventsList([]);
                        //Leer los datos del texto del pasado contenido web
                        datos.forEach((file) => {
                            leerArchivo(file)
                        });
                    } else
                        alert("Error, no se han podido obtener los datos desde el servidor");
                } else
                    alert("Error interno del servidor. No se ha podido obtener el contenido");
            } else
                alert("Error, no se ha recibido respuesta del servidor");
        }
        fetchRequest('getPastWebContents',
            [{nombre: 'ZipWebFileName', valor: ev.currentTarget.textContent}],
            'POST', ip, port, protocolo, 'json', callback,
            ['filename', 'mimeType', 'url'],
            modo_desarrollo);
    }

    /* Obtiene el documento correspondiente al link pulsado.
    Al pulsar el link, este pone su texto en el la propiedad ev.currentTarget.textContent */
    function requestFileByLinkName(ev) {
        ev.preventDefault(); // Evita que el enlace navegue o recargue la página
        //Obtener el texto que muestra el link (nombre del fichero a obtener)
        let nombre_fichero = ev.currentTarget.textContent;
        //Resetear los state
        resetStates();
        const callback = async (response) => {
            if (response) {
                if (response.data.getFileObjectByName) {
                    let dato = response.data.getFileObjectByName;
                    let file_data_object = {
                        url: dato.url,
                        name: nombre_fichero
                    }
                    setDocuments([file_data_object]);
                    setShowingDocument(() => true);
                } else
                    alert("Error interno del servidor. No se ha podido obtener el fichero compartido");
            } else
                alert("Error, no se ha recibido respuesta del servidor");
        }
        fetchRequest('getFileObjectByName',
            [{nombre: 'FileName', valor: ev.currentTarget.textContent}],
            'POST', ip, port, protocolo, 'json', callback,
            ['filename', 'mimeType', 'url'],
            modo_desarrollo);
    }

    /* Obtiene una array (ficheros zip subidos)  de arrays (imagenes en un zip subido ) de todas las imagenes web subidas la servidor */
    async function requestWebImages() {
        //Resetear states
        resetStates();
        console.log('Ejecutando petición de imágenes web al servidor');

        //Tratar la respuesta del  servidor
        const callback = async (response) => {
            //Si no hay respuesta o no se obtiene el contenido, mostrar error y salir
            if (!response || !response.data.getAllWebImages) {
                alert("Error en la respuesta del servidor");
                return;
            }
            //Extraer las imagenes y ponerlas en una array de arrays
            const datos = response.data.getAllWebImages;
            setShowingWebImages(true);
            let array_exterior = [];
            for (const file_array of datos) {
                let subArray = [];

                for (const file of file_array) {
                    const url = await leerArchivo(file, true);
                    if (url) subArray.push(url);
                }
                array_exterior.push(subArray);
            }
            // Aquí se actualiza el state cuando todo está listo
            setWebImagesArrays(array_exterior);
        };
        //Peticion al servidor
        fetchRequest(
            'getAllWebImages',
            [{ nombre: 'token', valor: '' }],
            'POST',ip,port,protocolo,'json',
            callback,[['filename', 'mimeType', 'url']],
            modo_desarrollo
        );
    }
    
    /* Obtiene una array de objetos con los datos de todos los ficheros compartidos */
    async function requestSharedDocuments()
    {
        //Resetear lo states
        resetStates();
        console.log('Ejecutando petición de documentos compartidos de todos los usuarios');

        //Tratar la respuesta del  servidor
        const callback = async (response) => {
            //Si no hay respuesta o no se obtiene el contenido, mostrar error y salir
            if (!response || !response.data.getAllSharedDocumentsData) {
                alert("Error en la respuesta del servidor");
                return;
            }
            const datos = response.data.getAllSharedDocumentsData; //Array de objeto datos de ficheros con el nombre del propietario incluido
            //Añadir un campo id a cada fila, necesario para el DataGrid
            const rowsWithId = datos.map((row, index) => ({
                id: row.filename,
                filename: row.filename.substring(row.filename.lastIndexOf('/')),
                ...row,
            }));
            // Setear la tabla de objetos que se pasa al nuevo subcomponente fileTable para que muestre los links y los datos
            // de los ficheros
            setSharedDocuments(rowsWithId);
            setShowingSharedDocuments(()=>true);
        };
        //Peticion al servidor
        fetchRequest(
            'getAllSharedDocumentsData',[{ nombre: 'token', valor: '' }],
            'POST',ip,port,protocolo,'json',
            callback,[['filename','description','owner','mimeType', 'uploadDate']], modo_desarrollo );
    }


    /* Obtiene una array de nombres de ficheros para mostrar como lista de links */
    function RequestFileNamesArray(requestType)
    {
        //Resetear los states
        resetStates();
        console.log('Ejecutando petición de nombres de ficheros del contenido: ', requestType, " al servidor");
        //Tratar la respuesta del  servidor
        const callback = (response) => {
            if (response) {
                if (response.data.getFileNamesArray) {
                    //Para lista de anuncios pasados
                    if(requestType === "pastAdvertisements") {
                        response.data.getFileNamesArray.forEach((file) => console.log("Fichero: ", file));
                        setPastWebNotices(response.data.getFileNamesArray);
                        setShowingPastNotices(true);
                    }
                    //Para lista de eventos pasados
                    else if(requestType === "pastEvents") {
                        let filtered_responses = [];
                        response.data.getFileNamesArray.forEach((unfiltered_event) => {
                            filtered_responses.push(unfiltered_event.substring(0, unfiltered_event.indexOf('.zip')));
                        })
                        setEventsList(filtered_responses);
                    }
                } else
                    alert("Error interno del servidor. No se ha podido obtener la lista de anuncios pasados.");
            } else
                alert("Error, no se ha recibido respuesta del servidor");
        }
        //Peticion al servidor
        fetchRequest('getFileNamesArray',
            [{nombre: 'requestType', valor:requestType}],
            'POST', ip, port, protocolo, 'json', callback,
            [],
            modo_desarrollo);
    }



    return (
        <Box style={{background: estiloPagina.background,height:'auto'}}>
            {/*Toolbar Barra de navegación */}
            <Box className='ToolBar'>
                <ToolBar
                    gadgets={[
                        <MenuDesplegable
                            key='1'
                            opciones={opciones}
                            opcionesOnClick={opcionesOnClick}>
                        </MenuDesplegable>]}
                    paginas={pages}
                    estilo={estiloPagina}
                    modo={modo}>
                </ToolBar>
            </Box>
            {/* Rotulo de la pagina */}
            <Box className='Cabecera'>
                <h1 style={{
                    margin: 'auto',
                    marginTop:'1%',
                    marginBottom:'1%',
                    color: (estiloPagina.background === 'black') ? WebTheme.colors.letraDark : WebTheme.colors.letraGreen,
                    fontWeight: 200
                }}>
                    Noticias y Actividades
                </h1>
            </Box>
            {/*Area de negocio */}
            <Box className='AreaNegocio' sx={{background:estiloPagina.background,height:'auto'}}>
                {/*Menu lateral*/}
                <MenuLateral
                    lateralMenuOnClick = {handleLateralMenuOptionsClick}
                    openSubMenu={openIndex}
                    lateralMenuSubOptionsOnClick = {handleLateralMenuSubOptions}
                    lateralMenuOptions = {lateralMenuOptions}
                    lateralMenuSubOptions = {lateralMenuSubOptions}
                    estilo = {estiloPagina}
                >
                </MenuLateral>
                {/* Para mostrar eventos web */}
                {eventsList.length === 0 && !showingWebImages && !showingDocument && !showingPastNotices && !showingSharedDocuments &&
                    <WebViewer
                     rotuloWeb={rotuloWeb}
                     textoWeb = {textosWeb[0]}
                     imagenesWeb={imagenesWeb}
                     type = {'event'}
                     estilo = {estiloPagina}
                    >
                    </WebViewer> }
                {/* Para mostrar links de eventos pasados */}
                {!showingWebImages && eventsList.length > 0 && !showingDocument &&
                    <WebViewer
                        eventsList={eventsList}
                        onLinkClicked={requestPastEventLink}
                        type = {'links'}
                        estilo = {estiloPagina}
                        rotuloLinks={"Links a eventos anteriores"}
                    >
                    </WebViewer> }
                {/* Para mostrar la galeria de imagenes */}
                { showingWebImages && webImagesArrays.length > 0 && !showingDocument &&
                    <ImageGalleryViewer
                        webImagesArrays={webImagesArrays}
                        textosWeb = {textosWeb}
                        estilo = {estiloPagina}
                    >
                    </ImageGalleryViewer>
                }
                {/* Para mostrar anuncios pdf */}
                {showingDocument &&
                <PdfViewer
                    estilo = {estiloPagina}
                    pdfArray = {documents}
                >
                </PdfViewer>
                }
                {/* Para mostrar links de anuncios pasados */}
                {!showingWebImages && pastWebNotices.length > 0 && !showingDocument && showingPastNotices &&
                <WebViewer
                    eventsList={pastWebNotices}
                    onLinkClicked = {requestFileByLinkName}
                    type = {'links'}
                    estilo = {estiloPagina}
                    rotuloLinks={"Lista de documentos anteriores"}
                >
                </WebViewer> }
                {/* Para mostrar una lista de ficheros compartidos */}
                {showingSharedDocuments && sharedDocuments.length > 0 &&
                    <Box sx={{marginLeft:'10%'}}>
                    <OraxTable
                    columns = {sharedDocumentsListColumns}
                    rows = {sharedDocuments}
                    tamañoLetra = '1.3em'
                    rotulo = 'Documentos compartidos'
                    >
                    </OraxTable>
                    </Box>}
            </Box>{/*Area de negocio */}
            <Footer estilo={estiloPagina} modo={modo}></Footer>
        </Box>
    )
}

/* Tenemos las siguientes peticiones:

   - requestUserDocumentLink -> getSharedDocument -> Obtiene el documento correspondiente al link pulsado en la tabla de documentos compartidos
   - requestNoticesLink -> getPastWebNotice -> Obtiene el comunicado (documentos) correspondiente al link pulsado en la lista de comunicados anteriores

**** Conclusion del analisis ************

    --- requestUserDocumentLink y requestNoticesLink: Obtienen un objeto File. Sustituibles por una funcion RequestFileByName
            -> Se pueden unificar sin mas puesto que lo determinante es el nombre del fichero a obtener que se obtiene al pulsar el link

Querdarian 5 peticiones en lugar de las 9 actuales requestWebImages
        requestWebImages y requestSharedDocuments, no se pueden unificar porque obtienen una array de arrays y una array de objetos específicos respectivamente
 */



